import Vue from 'vue'

// https://bootstrap-vue.js.org/docs
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import App from './App.vue'
import router from './router'
import store from './store'
import {func} from './func.js'

Vue.prototype.$func = func
Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  // dtrace('aaaaaaaaaaaaa', to)
  let title = null
  if (to.meta.titlefunc) {
    title = to.meta.titlefunc(to)
  } else {
    title = to.meta.title
  }

  if (!title) {
    return 'Ambiesoft'
  }

  // title = title.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
  //   return '&#' + i.charCodeAt(0) + ';';
  // });
  //title = escapeHtml(title)

  document.title = `${title} | Ambiesoft`
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

